export const replaceBrToSpace = (value: string) => {
  return value.replace(/<br\s*\/?>/, ' ');
};
